import { useCampaignContext } from 'modules/campaigns/editor/context';
import { CampaignState } from 'modules/domains/campaign';
import {
  ActivateCampaignAction,
  DeActivateCampaignAction,
  InAppRecallAction,
  ReActivateCampaignAction,
  ViewAnalyticsAction,
} from '../Actions';
import { CampaignSummaryOverflowMenu } from '../Actions/CampaignSummaryOverflowMenu';

/**
 * Mapper of actions for a given campaign state
 */
const TRIGGERED_CAMPAIGN_STATES_ACTION_COMPONENTS_MAPPER: Record<
  CampaignState,
  (() => JSX.Element | null)[]
> = {
  [CampaignState.Draft]: [ActivateCampaignAction],
  [CampaignState.Ready]: [ActivateCampaignAction],

  [CampaignState.Running]: [
    CampaignSummaryOverflowMenu,
    ViewAnalyticsAction,
    DeActivateCampaignAction,
  ],

  [CampaignState.Finished]: [
    CampaignSummaryOverflowMenu,
    InAppRecallAction,
    ViewAnalyticsAction,
    ReActivateCampaignAction,
  ],
  [CampaignState.Archived]: [ViewAnalyticsAction],

  [CampaignState.Recalled]: [ViewAnalyticsAction, ReActivateCampaignAction],
  [CampaignState.Recalling]: [InAppRecallAction, ViewAnalyticsAction],

  /**
   * These states are not available for Triggered campaigns
   */
  [CampaignState.Aborted]: [],
  [CampaignState.Recurring]: [],
  [CampaignState.Scheduled]: [],
};

export const TriggeredCampaignSummaryViewActions = () => {
  const {
    campaign: { campaignState },
  } = useCampaignContext();

  const actions = TRIGGERED_CAMPAIGN_STATES_ACTION_COMPONENTS_MAPPER?.[campaignState];

  return (
    <>
      {actions?.map((Action, i) => (
        <Action key={i} />
      ))}
    </>
  );
};
